<template>
  <div>
    <div class="footer">
      <div class="footer__flex">
        <div class="flex__reverse">
          <img
            class="footer__logo"
            src="@/assets/logo_full.svg"
            alt="David Veilleux Cabinet de services financiers"
          />
          <div class="footer__socials">
            <a
              v-for="(social, name) in $beet.options.general.socials"
              :key="'social-' + name"
              :href="social"
              target="_blank"
              class="footer__social"
            >
              <Icon :id="name" />
            </a>
          </div>
        </div>
        <div v-for="(address, index) in $beet.options.general.offices" :key="'place-' + index">
          <p class="footer__address">{{ address.name }}</p>
          <div class="footer__icon-line">
            <Icon id="address" class="footer__icon" />
            <div>{{ address.address }}</div>
          </div>
          <div class="footer__icon-line">
            <Icon id="phone" class="footer__icon" />
            <div>
              <div>{{ address.phone_1 }}</div>
              <div v-if="address.phone_2">{{ address.phone_2 }}</div>
            </div>
          </div>
          <div class="footer__icon-line">
            <Icon id="fax" class="footer__icon" />
            <div>{{ address.fax }}</div>
          </div>
        </div>
        <div class="footer__contact">
          <p class="paragraph">{{ $beet.options.general.open_hours }}</p>
          <LangRouterLink
            v-if="$beet.options.general.contact_page"
            :to="{ name: $beet.options.general.contact_page }"
            class="button mt-30"
            >{{ $beet.options.general.contact.button }}</LangRouterLink
          >
          <a
            v-else-if="$beet.options.general.contact_link"
            :href="$beet.options.general.contact_link"
            target="_blank"
            class="button mt-30"
            >{{ $beet.options.general.contact.button }}</a
          >
          <a href="https://portail.dvsf.ca" target="_blank" class="button__portal mt-30">
            {{ $t('secure') }}
            <Icon id="arrow" />
          </a>
        </div>
      </div>
      <div class="footer__investia">
        <img src="@/assets/investia.svg" alt="Investia" class="footer__investia-logo" />
        <p class="paragraph mt-30">{{ $beet.options.general.investia.text }}</p>
        <p class="mt-10">
          <a
            class="footer__investia-link"
            target="_blank"
            :href="$beet.options.general.investia.policy.link"
            >{{ $beet.options.general.investia.policy.text }}</a
          >
          -
          <LangRouterLink class="footer__investia-link" :to="{ name: 'disclaimer' }">{{
            $beet.options.general.investia.disclaimer
          }}</LangRouterLink>
          <template v-if="$beet.options.general.complaints_policy[$i18n.locale]?.length">
            -
            <a
              :href="$beet.options.general.complaints_policy[$i18n.locale][0]"
              class="footer__investia-link"
              target="_blank"
              >{{ $beet.options.general.complaints_policy.label[$i18n.locale] }}</a
            >
          </template>
          -
          <LangRouterLink class="footer__investia-link" :to="{ name: 'privacy-policy' }">{{
            $t('footer.privacyPolicy')
          }}</LangRouterLink>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'

export default {
  name: 'Footer',
  components: { Icon, LangRouterLink },
}
</script>
